import { createContext } from 'preact'
import type { ClientCompanyViewDto, ClientWorkspaceSummaryViewDto, ClientWorkspaceViewDto } from '@/types/company'

export interface CompanyState {
  companyId?: string | null
  company?: ClientCompanyViewDto | null
  workspaces: ClientWorkspaceSummaryViewDto[]
  authOrganizationId?: string | null
  hasEnabledAuthConnections?: boolean
  currentWorkspaceId?: string | null
  isLoading: boolean
  error?: string | null
  refresh: () => Promise<void>
  setCurrentWorkspace: (workspaceId: string) => void
  updateCompany: (company: ClientCompanyViewDto) => void
  // Both take the FULL workspace the create/update endpoints return. The provider narrows it to a
  // summary itself, because only it knows the company name a summary has to carry.
  addWorkspace: (ws: ClientWorkspaceViewDto) => void
  updateWorkspace: (ws: ClientWorkspaceViewDto) => void
  removeWorkspace: (workspaceId: string) => void
  currentWorkspace?: ClientWorkspaceSummaryViewDto | null
}

export const CompanyContext = createContext<CompanyState | null>(null)
